/**
 * The location fields for a newly uploaded attachment, of which **exactly one** is ever set.
 *
 * This mirrors what the server writes for a bot upload. A row carrying both would, if it later lost its
 * drive id through a partial write, still look like a valid legacy row and resolve silently to the team's
 * drive; with only the drive id it becomes unresolvable and loud instead. A file predating channel-scoped
 * storage has no drive id and keeps being addressed through its group.
 *
 * It imports nothing, so it is safe to use from the service layer as well as from components.
 */
export interface UploadSessionLocation {
  driveId?: string;
  groupId?: string;
}

export interface AttachmentLocation {
  DriveId?: string;
  DriveItemGroupId?: string;
}

export const attachmentLocation = (session: UploadSessionLocation): AttachmentLocation =>
  session?.driveId ? { DriveId: session.driveId } : { DriveItemGroupId: session?.groupId };
